import _ from 'lodash';
import { Mutation } from '@apollo/client/react/components';
import PropTypes from 'prop-types';
import React from 'react';

import {
  GET_APPROVALS,
  LIMIT,
  MARK_PROJECT_AS_DONE,
} from '../graphql';

import CapResponsesModal from '../cap-responses-modal';
import { ContainerParticipants, ContainerSpace } from '../styles';

import {
  Button,
  Container,
  ContainerDetails,
  Detail,
  OtherDetails,
} from './styles';

const handleMutationUpdate = (cache, { data: { markProjectAsDone } }, participantSource) => {
  const { approvals: cachedApprovals } = cache.readQuery({
    query: GET_APPROVALS,
    variables: {
      limit: LIMIT,
      offset: 0,
      participantSource: [participantSource],
    },
  });

  const { projectId } = markProjectAsDone;

  cache.writeQuery({
    query: GET_APPROVALS,
    data: {
      approvals: _.filter(
        cachedApprovals,
        (cachedApproval) => cachedApproval.project.id !== projectId,
      ),
    },
  });
};

const ApprovalAnalytics = (props) => {
  const {
    project,
    refetch,
  } = props;

  const { segments } = project;

  return (
    <Container>
      <ContainerDetails>
        <OtherDetails>
          Other Details:
        </OtherDetails>

        <Detail>
          Description:
          {' '}
          {project.description}
        </Detail>

        <Detail>
          Created by:
          {' '}
          {project.createdBy.profile.firstName}
          {' '}
          {project.createdBy.profile.lastName}
        </Detail>

        <Detail>
          # Participants:
          {' '}
          {project.audienceParticipants}

          <ContainerSpace>
            <div>
              {segments && segments.map((segment) => (
                <ContainerParticipants key={segment.id}>
                  <Detail>
                    {`${segment.name} # Participants: ${segment.audienceParticipants}`}
                  </Detail>
                  <CapResponsesModal
                    label="Response Cap"
                    projectId={project.id}
                    number={segment.audienceParticipants}
                    segmentId={segment.id}
                    refetch={refetch}
                  />
                </ContainerParticipants>
              ))}
            </div>
          </ContainerSpace>
        </Detail>
      </ContainerDetails>

      <div>
        <Mutation
          mutation={MARK_PROJECT_AS_DONE}
          update={(cache, mutation) => handleMutationUpdate(cache, mutation, project.participantsSource)}
          onCompleted={refetch}
        >
          {(markProjectAsDone, { loading }) => (
            <Button
              loading={loading}
              onClick={() => {
                markProjectAsDone({ variables: { projectId: project.id } });
              }}
            >
              Mark as Done
            </Button>
          )}
        </Mutation>
      </div>
    </Container>
  );
};

ApprovalAnalytics.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string,
    description: PropTypes.string,
    audienceParticipants: PropTypes.number,
    participantsSource: PropTypes.string,
    segments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      audienceParticipants: PropTypes.number,
    })),
    createdBy: PropTypes.shape({
      profile: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    }),
  }).isRequired,
  refetch: PropTypes.func.isRequired,
};

export default ApprovalAnalytics;
